import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Layout } from "@/components/layout/Layout";
import { Seo } from "@/components/seo/Seo";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CTAGroup } from "@/components/CTAGroup";
import { BRAND, SERVICE_AREAS } from "@/data/site";
import { breadcrumbSchema, orgSchema } from "@/lib/schema";

const ServiceAreas = () => (
  <Layout>
    <Seo
      title="Service Areas | Flooring Contractor Across Connecticut"
      description="VRP Flooring LLC installs flooring across Fairfield, New Haven and Hartford County — from Greenwich and Stamford to New Haven, West Hartford and beyond."
      jsonLd={[
        orgSchema(),
        breadcrumbSchema([
          { name: "Home", url: BRAND.website },
          { name: "Service Areas", url: `${BRAND.website}/service-areas` },
        ]),
      ]}
    />
    <section className="container-page py-12 md:py-16">
      <Breadcrumbs items={[{ name: "Home", href: "/" }, { name: "Service Areas" }]} />
      <div className="mt-6 max-w-3xl">
        <p className="eyebrow mb-4 text-accentInk">Service Areas</p>
        <h1 className="font-display text-4xl md:text-5xl font-bold mb-5">Local flooring installation, across Connecticut.</h1>
        <p className="text-muted-foreground text-lg">Headquartered in Danbury, we proudly serve homeowners and businesses throughout Fairfield, New Haven and Hartford County.</p>
      </div>
    </section>

    <section className="container-page pb-20">
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {SERVICE_AREAS.map((a) => (
          <Link key={a.slug} to={`/service-areas/${a.slug}`} className="card-elev p-7 group">
            <h2 className="font-display text-2xl font-semibold mb-2">{a.name}, {a.state}</h2>
            <p className="text-muted-foreground text-sm leading-relaxed mb-4">{a.intro}</p>
            <div className="flex flex-wrap gap-1.5 mb-4">
              {a.neighborhoods.slice(0, 3).map((n) => (
                <span key={n} className="text-xs bg-secondary px-2 py-1 rounded">{n}</span>
              ))}
            </div>
            <span className="inline-flex items-center gap-1 text-sm font-semibold text-accentInk">
              Explore {a.name} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </span>
          </Link>
        ))}
      </div>
    </section>

    <section className="bg-foreground text-background py-20">
      <div className="container-page text-center max-w-2xl">
        <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">Don't see your city?</h2>
        <p className="text-background/80 text-lg mb-8">We cover most of western Connecticut. Reach out and we'll confirm coverage for your address.</p>
        <CTAGroup variant="onDark" className="justify-center" />
      </div>
    </section>
  </Layout>
);

export default ServiceAreas;
